module.exports = __webpack_public_path__ + "img/checkout.35541057.png";